import { z } from "zod";

import { compose } from "@/common/helpers";
import {
  blocksSchema,
  extractBlocks,
  extractTranslations,
  imageSchema,
  promoBannerSchema,
  seoSchema,
} from "@/services/cms";

export const getHomepageResponseSchema = z
  .object({
    data: z.preprocess(
      compose(extractTranslations, extractBlocks),
      z
        .object({
          translations: z.object({
            seo: seoSchema,
            richHeading: z.string().min(3),
            buttonLabel: z.string().min(3),
            searchInputLabel: z.string().min(3),
            searchInputPlaceholder: z.string().min(3),
            heroImage: imageSchema,
            heroImageMedium: imageSchema,
            catalogueTestsLabel: z.string().min(3),
            catalogueTestsTitle: z.string().min(3),
            catalogueTestsSubtitle: z.string().min(3),
            testsLabel: z.string().min(3),
            testsTitle: z.string().min(3),
            testsSubtitle: z.string().min(3),
            ratingLabel: z.string().min(3),
            ratingTitle: z.string().min(3),
            ratingSubtitle: z.string().min(3),
            promoBanner: promoBannerSchema,
          }),
          blocks: blocksSchema,
        })
        .transform(
          ({
            translations: {
              ratingLabel,
              ratingTitle,
              ratingSubtitle,
              catalogueTestsLabel,
              catalogueTestsTitle,
              catalogueTestsSubtitle,
              testsLabel,
              testsTitle,
              testsSubtitle,
              ...translations
            },
            ...data
          }) => ({
            ...data,
            translations: {
              ...translations,
              stats: {
                catalogue: {
                  label: catalogueTestsLabel,
                  title: catalogueTestsTitle,
                  subtitle: catalogueTestsSubtitle,
                },
                tests: {
                  label: testsLabel,
                  title: testsTitle,
                  subtitle: testsSubtitle,
                },
                rating: {
                  label: ratingLabel,
                  title: ratingTitle,
                  subtitle: ratingSubtitle,
                },
              },
            },
          }),
        ),
    ),
  })
  .transform(({ data }) => ({ ...data }));
